import ctl from '@netlify/classnames-template-literals';

export const wrapperStyle = ctl(`
  flex 
  justify-center
  w-full
  h-14
  bg-waterspout 
`);

export const logotypeStyle = ctl(`
  font-bold 
  text-white 
  text-lg
`);

export const contentContainerStyle = ctl(`
  flex 
  justify-between 
  items-center 
  h-full 
  w-full
  app-container
  mt-0 
`);
